import React, { useState } from 'react';
import './MobileMenu.scss';
import Close from '../../UI/Icons/Close';
import { COLORS } from '../../../constants/colors';
import CTAButton from '../../UI/CTA/CTAButton/CTAButton';

const MobileMenu = ({ links, menuOpen, handleToggle, linkItems, login, cta }) => {
  const [detailsOpen, setDetailsOpen] = useState(0);

  const renderDetails = (data) =>
    data.map((link, i) => (
      <details
        className="c-mobile-menu__category-wrapper"
        open={() => (i === 0 ? true : detailsOpen === i)}
        onClick={() => setDetailsOpen(i)}
      >
        <summary className="c-mobile-menu__category-title h2-right-grotesk color-gray">
          {data[i]}
        </summary>
        <ul className="c-mobile-menu__category">
          {links[link].map((item) => (
            <li className="c-mobile-menu__category-item">
              <a className="c-mobile-menu__link color-gray h4-roobert" href={item.url}>
                {item.title}
              </a>
            </li>
          ))}
        </ul>
      </details>
    ));

  return (
    <div className={`c-mobile-menu ${menuOpen ? 'is-open' : ''}`}>
      <div className="c-mobile-menu__heading">
        <button className="c-mobile-menu__close-btn" onClick={handleToggle}>
          <Close color={COLORS.gray} />
        </button>
        <div className="c-mobile-menu-heading__cta">
          <a href={login.url} className="c-mobile-menu__login-link color-black">
            {login.text}
          </a>
          <CTAButton
            type={'secondary'}
            link={cta.url}
            text={cta.text}
            target={'_self'}
            additionalClasses={'color-black cta'}
          />
        </div>
      </div>
      <div className="c-mobile-menu__list">{renderDetails(linkItems)}</div>
    </div>
  );
};

export default MobileMenu;
